import { Resource } from './resource';
import gql from 'graphql-tag';

export class CardResource extends Resource {
  public static async checkout(cardNumber: string) {
    return await this.mutation(
      {
        mutation: gql`
          mutation($cardNumber: String!) {
            startOrEndWork(cardNumber: $cardNumber) {
              id
              start
              end
              date
              company {
                name
              }
              user {
                firstName
                lastName
              }
            }
          }
        `,
        variables: { cardNumber }
      },
      'startOrEndWork'
    );
  }

  public static async add(schema: any, userId: number) {
    return await this.mutation(
      {
        mutation: gql`
          mutation($companyId: Int!, $number: String!, $userId: Int!) {
            addCard(companyId: $companyId, number: $number, userId: $userId) {
              id
              number
              company {
                id
                name
              }
            }
          }
        `,
        variables: { companyId: schema.$model.companyId, number: schema.$model.cardNumber, userId }
      },
      'addCard'
    );
  }

  public static async update(id: number, schema: any, userId: number) {
    return await this.mutation(
      {
        mutation: gql`
          mutation($id: Int!, $companyId: Int, $number: String, $userId: Int) {
            updateCard(id: $id, companyId: $companyId, number: $number, userId: $userId) {
              id
              number
              company {
                id
                name
              }
            }
          }
        `,
        variables: { id, companyId: schema.$model.companyId, number: schema.$model.cardNumber, userId }
      },
      'updateCard'
    );
  }

  public static async delete(id: number) {
    await this.mutation({
      mutation: gql`
        mutation($id: Int!) {
          removeCard(id: $id)
        }
      `,
      variables: { id }
    });
  }
}
